/**
 * Check if a date should be null:
 * if it is "0001-01-01 00:00:00"
 * convert it to null or provide the date
 */



export const CheckNullDate = (date) => {

    // Define null date
    const nullDate = "0001-01-01 00:00:00";

   

    // Check if the date matches the null date, if so return null otherwise return the original date
    return date === nullDate ? null : date;

};